import React from 'react';
import { Link } from 'react-router-dom';

const AboutUs = () => {
    return (
        <div className="container py-5">
            {/* Header */}
            <div className="text-center mb-5">
                <h1 className="display-5 fw-bold text-teal mb-3">About Shopy Sync</h1>
                <p className="lead text-muted" style={{ maxWidth: '720px', margin: '0 auto' }}>
                    <strong>Google Sheets → Shopify</strong>: Bulk add, update, and delete — <em>simple, fast, and safe</em>.
                </p>
            </div>

            {/* Main Content */}
            <div className="row justify-content-center">
                <div className="col-lg-8">

                    {/* Core Purpose */}
                    <div className="text-center mb-5">
                        <div className="bg-light p-4 rounded shadow-sm">
                            <h2 className="h5 fw-bold text-teal mb-3">Why We Built This App</h2>
                            <p className="mb-0 text-muted" style={{ fontSize: '1.1rem' }}>
                                So you can <strong>edit products in Google Sheets</strong> and
                                <strong> sync them to Shopify in one simple step</strong> —
                                no manual exports, no CSV errors, no stress.
                            </p>
                        </div>
                    </div>

                    {/* From India */}
                    <div className="text-center">
                        <h2 className="h5 fw-bold text-teal mb-3">Made in India</h2>
                        <p className="text-muted" style={{ maxWidth: '600px', margin: '0 auto', fontSize: '1.05rem' }}>
                            A small team from India, building tools that <em>just work</em> —
                            so you can focus on your store, not data headaches.
                        </p>
                    </div>

                </div>
            </div>

            {/* CTA */}
            <div className="text-center mt-5">
                <Link
                    to="/how-it-works"
                    className="btn btn-teal btn-lg px-5"
                    style={{
                        backgroundColor: '#0d9488',
                        color:'#ffffff',
                        border: 'none',
                        borderRadius: '8px',
                        fontWeight: '600'
                    }}
                >
                    See How It Works
                </Link>
            </div>
        </div>
    );
};

export default AboutUs;